import React, { useState } from 'react';
import useRefetchOnAppFocus from '../../hooks/use-refetch-on-app-focus';
import useOpeningStateChannel from '../../websocket/hooks/use-opening-state-channel';
import useWakeSleepChannel from '../../websocket/hooks/use-wake-sleep-channel';
import { useTerminalSetting } from '../../contexs/terminal-setting-context';
import { View, useWindowDimensions } from 'react-native';
import { getContainerClass } from '../../utils/conditional-style';
import { tw } from '../../utils/tailwind';
import { OnboardingPopup } from '../../components/web/onboarding-popup';
import { AppStackScreenProps } from '../../routes';
import { CashRegisterNavigation } from '../../components/navigations/cash-register-navigation';
import { OrdersNavigation } from '../../components/navigations/orders-navigation';
import { CurrentOrdersList } from './current-orders-list';
import QuerySuspense from '../../api/query-suspense';
import { useCartsQueries } from '../../api/hooks/vendor/carts/use-carts-queries';
import SplashScreen from '../splash/splash.screen';
import { useQueryClient } from '@tanstack/react-query';
import { SetOrdersDoneButton } from '../../components/vendor/set-orders-done-button';
import { useOrderWorkflowHandler } from '../../hooks/use-order-workflow-handler';

interface VendorDashboardScreenProps {
  navigation: AppStackScreenProps<'VendorDashboard'>['navigation'];
}

export const VendorDashboardScreen = (props: VendorDashboardScreenProps) => {
  // Standard hooks
  const queryClient = useQueryClient();
  const { width } = useWindowDimensions();
  const { store_app_type } = useTerminalSetting();
  // States & Queries
  const { fetchCarts } = useCartsQueries();
  const [isOnboarding, setIsOnboarding] = useState(
    // Show onboarding only if user is not navigating to this screen
    !props.navigation.canGoBack(),
  );

  const isNative = store_app_type === 'native';

  // Connect to a websocket and listen for new orders
  useRefetchOnAppFocus();
  useOpeningStateChannel();
  useOrderWorkflowHandler();
  // React native
  useWakeSleepChannel();

  return (
    <>
      <View style={tw`${getContainerClass(width, 24)} flex-1`}>
        {/* Show onboarding popup */}
        {isOnboarding && !isNative && (
          <OnboardingPopup
            onConfirm={() => {
              setIsOnboarding(false);
            }}
          />
        )}

        <QuerySuspense
          query={fetchCarts}
          loadingComponent={<SplashScreen />}
          onSuccess={data => (
            <CurrentOrdersList
              isNative={isNative}
              orders={data}
              refreshing={fetchCarts.isRefetching}
              onRefresh={() => {
                fetchCarts.refetch();
                queryClient.invalidateQueries({
                  queryKey: ['tenantsDashboard'],
                });
              }}
            />
          )}
        />
      </View>

      <CashRegisterNavigation isOnVendorScreen={true} />
    </>
  );
};
